import { useState, useEffect, useRef } from 'react';

export const useMultiselectMenuControl = (isMultiSelect) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const lastActionRef = useRef(null);
  const selectWrapperRef = useRef(null);

  useEffect(() => {
    if (!isMultiSelect) return;

    const handleControlClick = (event) => {
      if (selectWrapperRef.current && selectWrapperRef.current.contains(event.target)) {
        const controlElement = selectWrapperRef.current.querySelector('[class*="control"]');
        if (controlElement && controlElement.contains(event.target)) {
          setMenuIsOpen(!menuIsOpen);
        }
      }
    };

    document.addEventListener('mousedown', handleControlClick);
    return () => {
      document.removeEventListener('mousedown', handleControlClick);
    };
  }, [isMultiSelect, menuIsOpen]);

  useEffect(() => {
    if (!isMultiSelect) return;

    const handleDocumentClick = (event) => {
      const isControl = event.target.closest('[class*="control"]');
      const isMenu = event.target.closest('[class*="menu"]');
      const isSelectWrapper = selectWrapperRef.current && selectWrapperRef.current.contains(event.target);
      const isStickyHeader = event.target.closest('[class*="sticky-header"]');
      
      // Close menu if:
      // 1. Click is outside both control and menu, OR
      // 2. Click is on sticky header background but not on the select control itself
      const isOnStickyHeaderBackground = isStickyHeader && !isControl && !isSelectWrapper;
      const isOutside = !isControl && !isMenu;
      
      if ((isOutside || isOnStickyHeaderBackground) && menuIsOpen) {
        setMenuIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick, true);
    document.addEventListener('mousedown', handleDocumentClick, true);
    
    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('mousedown', handleDocumentClick, true);
    };
  }, [isMultiSelect, menuIsOpen]);

  return {
    menuIsOpen,
    setMenuIsOpen,
    selectWrapperRef,
    lastActionRef
  };
};

